import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";
import * as React from "react";
import { BooleanInput, FormWithRedirect, TextInput, Toolbar, required } from "react-admin";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import CreatedByInput from "../../../../Components/ReferenceFields/CreatedBy/CreatedByInput";

const MelCategoryEditForm = props => {
  return (
    <FormWithRedirect
      {...props}
      render={(formProps: any) => (
        <Card>
          <form>
            <CardContent>
              <Box display={{ md: "block", lg: "flex" }}>
                <Box flex={2}>
                  <Grid container direction="row" justify="space-between" alignItems="flex-start">
                    <Typography variant="h6" gutterBottom color="primary">
                      Creation Information
                    </Typography>
                    <BooleanInput label="Active/Passive" source="isActive" />
                  </Grid>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1}>
                      <TextInput source="categoryCode" label="CATEGORY CODE" validate={required()} fullWidth disabled />
                    </Box>
                  </Box>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <CreatedByInput fullWidth disabled />
                    </Box>
                    <Box flex={1} ml={{ xs: 0, sm: "0.5em" }}>
                      <CustomDatetime source="createdDate" label="CREATED DATE" fullWidth showTime disabled />
                    </Box>
                  </Box>
                  <Box mt="1em" />
                  <Typography variant="h6" gutterBottom color="primary">
                    Updatable Field
                  </Typography>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <TextInput
                        source="categoryName"
                        label="CATEGORY NAME"
                        fullWidth
                        resettable
                        validate={[required()]}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </CardContent>
            <Toolbar
              {...props}
              placeholder=""
              record={formProps.record}
              basePath={formProps.basePath}
              undoable={true}
              invalid={formProps.invalid}
              handleSubmit={formProps.handleSubmit}
              saving={formProps.saving}
              resource="melcategorys"
            />
          </form>
        </Card>
      )}
    />
  );
};

export default MelCategoryEditForm;
